module.exports = __webpack_public_path__ + "img/gallery09.adfc4b05.png";